




































































































































































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
  Ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';

import useDriverProfile from '@/useDriverProfile';
import useAuth from '@/useAuth';

import getDriver from '@/gql/driver/getDriver.gql';
import createDriver from '@/gql/driver/createDriver.gql';
import deleteDriver from '@/gql/driver/deleteDriver.gql';
import restoreDriver from '@/gql/driver/restoreDriver.gql';
import updateDriver from '@/gql/driver/updateDriver.gql';
import uploadDriverDocument from '@/gql/driver/uploadDriverDocument.gql';
import uploadDriverAvatar from '@/gql/driver/uploadDriverAvatar.gql';
import uploadDriverSignature from '@/gql/driver/uploadDriverSignature.gql';
import checkUsernameExists from '@/gql/driver/checkUsernameExists.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonMultiCheckboxWithIcon from '@/components/CommonMultiCheckboxWithIcon.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';
import CommonPanelWithDriverAbsenceLog from '@/components/Setting/CommonPanelWithDriverAbsenceLog.vue';

const CommonFormWithDriverEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonMultiCheckboxWithIcon,
    GroupAddressEditor,
    CommonPanelWithDriverAbsenceLog,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { me } = useAuth();
    const { transformToInteger, integerToArray } = useDriverProfile();
    const allowToSubmitForm = ref(true);
    const NOW = new Date();
    const driver = reactive({
      id: -1,
      name: '',
      employeeCode: '',
      primaryTelephone: '',
      secondaryTelephone: '',
      dateOfBirth: NOW,
      citizenId: '',
      address: {
        address: '',
        province: {
          id: '',
        },
        district: {
          id: '',
        },
        subdistrict: {
          id: '',
        },
        zipcode: '',
        telephone: '',
      },
      avatarUrl: '',
      signatureUrl: '',
      availableVehicleType: [false, false, false, false],
      active: false,
      driverLicenseType: 0,
      driverLicenseExpireDate: NOW,
      username: '',
      password: '',
      confirmPassword: '',
      absenceLogs: [],
      deletedAt: '',
    });

    const { route } = useRouter();
    const { result: getOldDriverResult, loading } = useQuery(getDriver, computed(() => ({
      id: route.value.params.id,
      trashed: 'WITH',
    })), () => ({ fetchPolicy: 'network-only' }));
    const oldOrderResult = useResult(getOldDriverResult, {}, (data) => data.driver);
    watch(() => oldOrderResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.edit) {
        const driverDateOfBirth = new Date(oldOrderResult.value?.dateOfBirth);
        driver.id = oldOrderResult.value?.id;
        driver.name = oldOrderResult.value?.name;
        driver.dateOfBirth = driverDateOfBirth;

        driver.employeeCode = oldOrderResult.value?.employeeCode;
        driver.primaryTelephone = oldOrderResult.value?.primaryTelephone;
        driver.secondaryTelephone = oldOrderResult.value?.secondaryTelephone;
        driver.citizenId = oldOrderResult.value?.citizenId;
        driver.availableVehicleType = integerToArray(oldOrderResult.value?.availableVehicleType) || [false, false, false, false];
        driver.active = oldOrderResult.value?.active;
        driver.avatarUrl = oldOrderResult.value?.avatarUrl;
        driver.signatureUrl = oldOrderResult.value?.signatureUrl;
        driver.driverLicenseExpireDate = oldOrderResult.value?.driverLicenseExpireDate;

        driver.absenceLogs = oldOrderResult.value?.absenceLogs;

        driver.username = oldOrderResult.value?.username;
        driver.password = '';
        driver.confirmPassword = '';

        driver.address = {
          address: oldOrderResult.value?.address.address || '',
          province: oldOrderResult.value?.address.province || { id: null },
          district: oldOrderResult.value?.address.district || { id: null },
          subdistrict: oldOrderResult.value?.address.subdistrict || { id: null },
          zipcode: oldOrderResult.value?.address.zipcode,
          telephone: oldOrderResult.value?.address.telephone,
        };

        driver.deletedAt = oldOrderResult.value?.deletedAt;
      }
    });

    const driverInput = computed(() => ({
      name: driver.name,
      employeeCode: driver.employeeCode,
      primaryTelephone: driver.primaryTelephone,
      secondaryTelephone: driver.secondaryTelephone,
      dateOfBirth: `${useFormat.date(driver.dateOfBirth).computerShortDate()}`,
      citizenId: driver.citizenId,
      address: {
        ...driver.address,
        address: driver.address.address,
        province: driver.address.province.id,
        district: driver.address.district.id,
        subdistrict: driver.address.subdistrict.id,
        zipcode: `${driver.address.zipcode}`,
      },
      availableVehicleType: transformToInteger(driver.availableVehicleType),
      active: driver.active,
      driverLicenseType: '',
      driverLicenseExpireDate: `${useFormat.date(driver.driverLicenseExpireDate).computerShortDate()}`,
      driverLicenseDocument: '',
      username: driver.username !== '' ? driver.username : undefined,
      password: driver.password !== '' ? driver.password : undefined,
      companyId: props.edit ? undefined : me.company.id,
    }));

    const refetchQueries = ['getDrivers', 'getDriver'];
    const createDriverMutation = useMutation(createDriver, () => ({
      variables: {
        input: driverInput.value,
      },
      refetchQueries,
    }));
    const updateDriverMutation = useMutation(updateDriver, () => ({
      variables: {
        id: route.value.params.id,
        input: driverInput.value,
      },
      refetchQueries,
    }));
    const confirmModal = ref(null);
    const redirectId = ref(-1);
    createDriverMutation.onDone((data: any) => {
      redirectId.value = data.data.createDriver?.id;
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateDriverMutation.onDone((data: any) => {
      redirectId.value = data.data.updateDriver?.id;
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createDriverMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateDriverMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.edit) return updateDriverMutation;
      return createDriverMutation;
    });

    const uploadDriverAvatarMutation = useMutation(uploadDriverAvatar, {
      refetchQueries,
    });
    const uploadDriverAvatarVariables = computed(() => {
      if (route.value.params.id !== null) return { id: route.value.params.id };
      return {};
    });

    const uploadDriverDocumentMutation = useMutation(uploadDriverDocument, {
      refetchQueries,
    });
    const uploadDriverDocumentVariables = computed(() => {
      if (route.value.params.id !== null) return { id: route.value.params.id };
      return {};
    });
    const uploadDriverSignatureMutation = useMutation(uploadDriverSignature, {
      refetchQueries,
    });

    // This part use to check username
    const usernameValidationRules: { required: boolean; excluded: string[] } = reactive({
      required: !props.edit,
      excluded: [],
      min: 8,
    });
    const checkUsernameExistsMutation = useMutation(checkUsernameExists, () => ({
      variables: {
        id: driver.id,
        username: driver.username,
      },
    }));
    const checkUsernameExistsAction = _.debounce(() => {
      checkUsernameExistsMutation.mutate();
      allowToSubmitForm.value = false;
    }, 500);
    checkUsernameExistsMutation.onDone((result: any) => {
      if (result.data.checkUsernameExists.exists && result.data.checkUsernameExists.driver.id !== driver.id) {
        if (!(usernameValidationRules.excluded.indexOf(driver.username) > -1)) usernameValidationRules.excluded.push(driver.username);
      } else allowToSubmitForm.value = true;
    });

    const refetchQueriesList = [
      'getDrivers', 'getDriver',
    ];
    const deleteDriverModal = ref(null);
    const deleteDriverMutation = useMutation(deleteDriver, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDriverAction(driverId: number) {
      deleteDriverMutation.mutate({
        id: driverId,
      });
    }

    const restoreDriverMutation = useMutation(restoreDriver, {
      refetchQueries: refetchQueriesList,
    });
    function restoreDriverAction(driverId: number) {
      restoreDriverMutation.mutate({
        id: driverId,
      });
    }

    return {
      loading,
      allowToSubmitForm,
      driver,

      computedMutation,

      confirmModal,
      errorModal,

      // upload mutation
      uploadDriverAvatarMutation,
      uploadDriverAvatarVariables,
      uploadDriverDocumentMutation,
      uploadDriverDocumentVariables,
      uploadDriverSignatureMutation,

      checkUsernameExistsAction,
      usernameValidationRules,

      redirectId,

      deleteDriverModal,
      deleteDriverMutation,
      deleteDriverAction,

      restoreDriverAction,
    };
  },
});

export default CommonFormWithDriverEditor;
